var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-item-m",
      class: { active: _vm.isActive },
      attrs: { align: "center" },
      on: {
        click: function($event) {
          _vm.navigatorItemClick()
        }
      }
    },
    [
      _c("div", {}, [
        _c(
          "div",
          {},
          [
            _c("Icon", {
              staticClass: "nav-icon",
              attrs: { name: _vm.item.icon }
            }),
            _vm._v(" "),
            _vm.item.eventStatus != "submitted"
              ? _c("a", { staticClass: "nav-text" }, [
                  _vm._v(_vm._s(_vm.item.name))
                ])
              : _c("a", { staticClass: "nav-text" }, [
                  _vm._v(_vm._s(_vm.item.name) + " \n        "),
                  _c("div", { staticClass: "company-name" }, [
                    _vm._v(_vm._s(_vm.item.companyName))
                  ])
                ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-number" }, [_vm._v(_vm._s(_vm.number))]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-underline", class: _vm.item.lineColor })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-441e2b35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441e2b35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatedEvents/EventStatusSelection.vue
// module id = 1500
// module chunks = 1